/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
 import { BrowserModule } from '@angular/platform-browser'
 import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
 import { NgModule } from '@angular/core'
 import { HttpClientModule, HttpClient, HttpClientXsrfModule } from '@angular/common/http'
 import { RouterModule } from '@angular/router'
 
 import { TranslateModule, TranslateLoader } from '@ngx-translate/core'
 import { TranslateHttpLoader } from '@ngx-translate/http-loader'
 
 import { CoreModule } from './@core/core.module'
 import { ThemeModule } from './@theme/theme.module'
 import { AppComponent } from './app.component'
 
 // import { AppRoutingModule } from './app-routing.module'
 import { ROUTES } from './app.routes'
 
 let origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
 let isDev = (window.location.hostname === 'localhost')
 
 const localhostServerUrl = 'http://localhost:5000'
 const SERVER_URL = isDev ? localhostServerUrl : origin.replace('admin', 'api')
 
 export function createTranslateLoader(http: HttpClient) {
   return new TranslateHttpLoader(http, './assets/i18n/', '.json');
 }
 
 import {
   NbChatModule,
   NbDatepickerModule,
   NbDialogModule,
   NbMenuModule,
   NbSidebarModule,
   NbToastrModule,
   NbWindowModule,
 } from '@nebular/theme'
 import { ApiModule } from '@api/core'
 import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgSelectModule } from '@ng-select/ng-select'
import { DragulaModule } from 'ng2-dragula'
 
 @NgModule({
   declarations: [AppComponent],
   imports: [
     BrowserModule,
     BrowserAnimationsModule,
     HttpClientModule,
     HttpClientXsrfModule.withOptions({
      cookieName: 'XSRF-TOKEN',
      headerName: 'X-XSRF-TOKEN'
     }),
     RouterModule.forRoot(ROUTES),
     NbSidebarModule.forRoot(),
     NbMenuModule.forRoot(),
     NbDatepickerModule.forRoot(),
     NbDialogModule.forRoot(),
     NbWindowModule.forRoot(),
     NbToastrModule.forRoot(),
     NbChatModule.forRoot({
       messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
     }),
     CoreModule.forRoot(),
     ThemeModule.forRoot(),
     SweetAlert2Module.forRoot(),
     TranslateModule.forRoot({
       defaultLanguage: 'en',
       loader: {
         provide: TranslateLoader,
         useFactory: (createTranslateLoader),
         deps: [HttpClient]
       }
     }),
     ApiModule.forRoot({
       serverURL: SERVER_URL
     }),
     FormsModule,
     ReactiveFormsModule,
     DragulaModule.forRoot(),
     NgSelectModule,
   ],
   bootstrap: [AppComponent],
 })
 export class AppModule {
 }
 